export const SET_ORDERS = 'SET_ORDERS'

export const API_ORDERS_FETCH_ALL_START = 'API_ORDERS_FETCH_ALL_START'
export const API_ORDERS_FETCH_ALL_SUCCESS = 'API_ORDERS_FETCH_ALL_SUCCESS'
export const API_ORDERS_FETCH_ALL_FAILURE = 'API_ORDERS_FETCH_ALL_FAILURE'

export const API_ORDERS_CREATE_START = 'API_ORDERS_CREATE_START'
export const API_ORDERS_CREATE_SUCCESS = 'API_ORDERS_CREATE_SUCCESS'
export const API_ORDERS_CREATE_FAILURE = 'API_ORDERS_CREATE_FAILURE'
